import { cn } from '@/lib/utils'

export function CardSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn('overflow-hidden rounded-xl border border-white/5 bg-ink-800', className)}>
      <div className="skeleton aspect-[2/3] w-full" />
      <div className="space-y-2 p-2.5">
        <div className="skeleton h-3 w-3/4 rounded" />
        <div className="skeleton h-2.5 w-1/3 rounded" />
      </div>
    </div>
  )
}

export function GridSkeleton({ count = 12 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
      {Array.from({ length: count }).map((_, i) => (
        <CardSkeleton key={i} />
      ))}
    </div>
  )
}

export function RowSkeleton() {
  return (
    <div className="flex gap-3 overflow-hidden">
      {Array.from({ length: 8 }).map((_, i) => (
        <CardSkeleton key={i} className="w-[150px] shrink-0 sm:w-[170px]" />
      ))}
    </div>
  )
}

export function DetailSkeleton() {
  return (
    <div>
      <div className="skeleton h-[45vh] w-full sm:h-[60vh]" />
      <div className="container-page -mt-24 space-y-4">
        <div className="skeleton h-10 w-2/3 rounded-lg" />
        <div className="skeleton h-4 w-1/2 rounded" />
        <div className="skeleton h-24 w-full rounded-lg" />
      </div>
    </div>
  )
}
